import React, { useEffect, useRef, useState } from "react";
import { Table, Input, Button, message, Typography } from "antd";
import {
  CopyOutlined,
  SearchOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Highlighter from "react-highlight-words";
import apis from "../../../services/Apis";
import { SecurePost } from "../../../services/axiosCall";
import Alert from "../../common/alert";
// import {
//   changeConducttestId,
//   updateCandidatesTest,
// } from "../../../actions/conductTest";
import { changeCandidatesOfTest } from "../../../reducers/conductTest";
import "./conducttes.css";

const { Title } = Typography;

const Candidates = () => {
  const dispatch = useDispatch();
  const searchInput = useRef(null);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [mainlink, setMainlink] = useState("");

  const conduct = useSelector((state) => state.conductTest);
  // console.log("Conduct",conduct);
  

  useEffect(() => {
    const parts = window.location.href.split("/").splice(0, 3);
    const base = parts.join("/") + "/";
    setMainlink(base);
    refreshUserList();
  }, []);

  const refreshUserList = () => {
    setLoading(true);
    SecurePost({
      url: apis.GET_TEST_CANDIDATES,
      data: { id: conduct.id },
    })
      .then((response) => {
        if (response.data.success) {
          dispatch(changeCandidatesOfTest(response.data.data));
        } else {
          Alert("error", "Error!", response.data.message);
        }
        setLoading(false);
      })
      .catch((error) => {
        const msg = error.response
          ? error.response.data.message
          : error.message;
        Alert("error", "Error!", msg);
        setLoading(false);
      });
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters,confirm) => {
    clearFilters();
    confirm();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters,confirm)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps:{
    onOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  },
    render: (text) =>
      searchText ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text?.toString() || ""}
        />
      ) : (
        text
      ),
  });
  const nameColumnSearchProps = getColumnSearchProps("name");
  const emailColumnSearchProps = getColumnSearchProps("emailid");
  const contactColumnSearchProps = getColumnSearchProps("contact");

  const columns = [
    {
      title: <span style={{ color: "black" }}>Name</span>,
      dataIndex: "name",
      key: "name",
      ...nameColumnSearchProps,
      render: (text) => {
        const defaultRendered = nameColumnSearchProps.render
          ? nameColumnSearchProps.render(text)
          : text;

        return <span style={{ color: "black" }}>{defaultRendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Email Id</span>,
      dataIndex: "emailid",
      key: "emailid",
      ...emailColumnSearchProps,
      render: (text) => {
        const defaultRendered = emailColumnSearchProps.render
          ? emailColumnSearchProps.render(text)
          : text;

        return <span style={{ color: "black" }}>{defaultRendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Contact No</span>,
      dataIndex: "contact",
      key: "contact",
      ...contactColumnSearchProps,
      render: (text) => {
        const defaultRendered = contactColumnSearchProps.render
          ? contactColumnSearchProps.render(text)
          : text;

        return <span style={{ color: "black" }}>{defaultRendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Links</span>,
      key: "_id",
      dataIndex: "_id",
      render: (id) => {
        const testLink = `${mainlink}#/trainee/taketest?testid=${conduct.id}&traineeid=${id}`;
        return (
          <Input
            disabled
            value={testLink}
            addonAfter={
              <CopyToClipboard
                text={testLink}
                onCopy={() => message.success("Link copied to clipboard")}
              >
                <CopyOutlined />
              </CopyToClipboard>
            }
          />
        );
      },
    },
  ];

  return (
    <div className="candidate-list-header-container">
      <Button
        className="reload-button"
        type="primary"
        icon={<ReloadOutlined />}
        loading={loading}
        onClick={refreshUserList}
      >
        Reload!
      </Button>
      <div className="register-trainer-form-header">
        <Title
          level={4}
          style={{ color: "#fff", textAlign: "center", margin: -5 }}
        >
          List of Registered Candidates
        </Title>
      </div>
      <Table
        columns={columns}
        bordered
        dataSource={conduct.registeredCandidates}
        rowKey="_id"
        loading={loading}
        style={{ backgroundColor: "#fff", padding: "10px" }}
      />
    </div>
  );
};

export default Candidates;
